import type { IconData } from '@stacksjs/iconify-core'

export const iDental: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M32.119 34.179c4.725 0 6.916 3.587 7.378 8.679c.109 1.219-.005 2.995-.161 5.053c-.531 6.836-1.142 15.236 3.41 15.236c3.849 0 5.827-7.386 6.968-15.804c1.102-8.334-.065-12.481.508-16.181c1.094-7.011 7.215-13.297 5.324-22.237c-1.047-4.959-3.777-7.292-6.483-8.272c-6.231-2.268-10.255 2.102-16.946 2.102S21.403-1.615 15.169.653c-2.703.98-5.433 3.313-6.482 8.272c-1.889 8.939 4.229 15.226 5.326 22.237c.573 3.7-.593 7.847.509 16.181c1.141 8.419 3.119 15.804 6.968 15.804c4.549 0 3.942-8.4 3.41-15.236c-.156-2.057-.271-3.834-.162-5.053c.46-5.092 2.682-8.679 7.379-8.679z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iDental
